/**
 * Резолв id счётчика Яндекс.Метрики из сборочного ENV — ОДНА реализация на весь
 * фронт (загрузчик тега + отправка целей).
 *
 * Вынесено в отдельный модуль после того, как вторая, «своя» копия чтения id в
 * `yandexMetrika.ts` оказалась мёртвой: в ней стоял охранник
 * `typeof process !== "undefined" ? process.env.REACT_APP_YM_COUNTER_ID : ""`.
 * webpack DefinePlugin (см. webpack.config.js) подставляет строковый литерал
 * ТОЛЬКО вместо полного выражения `process.env.REACT_APP_YM_COUNTER_ID`, а сам
 * охранник остаётся в бандле как есть — и в браузере даёт false, потому что
 * глобального `process` там нет. Итог: id всегда «», а каждый вызов reachGoal
 * молча уходил в никуда.
 *
 * Поэтому обращение к `process.env` здесь ГОЛОЕ, без единой проверки вокруг —
 * ровно так, как это обязано выглядеть, чтобы подстановка сработала.
 */
/**
 * Разбор сырого значения счётчика. Валидным считаем только строку из цифр
 * (id счётчика Метрики — целое число); всё прочее, включая пустую строку
 * «счётчик не сконфигурирован», даёт null.
 */
export function parseMetrikaCounterId(raw) {
    if (typeof raw !== "string") {
        return null;
    }
    const trimmed = raw.trim();
    if (!/^\d+$/.test(trimmed)) {
        return null;
    }
    const value = parseInt(trimmed, 10);
    return Number.isFinite(value) ? value : null;
}
/** id счётчика из ENV сборки (`REACT_APP_YM_COUNTER_ID`) либо null. */
export function getMetrikaCounterIdFromEnv() {
    return parseMetrikaCounterId(process.env.REACT_APP_YM_COUNTER_ID);
}
